import { OrderContact } from "../api/ApiTypes.ts";
import {ChevronDown, ChevronRight, Mail, Phone, User, Contact} from "lucide-react";
import { useState } from "react";
import {formatPhone} from "../utils/phoneUtil.ts";

export const PropertyContactDisplay = ({ contact }: { contact: OrderContact }) => {
    if (!contact) return null;

    const [showPhones, setShowPhones] = useState(true);

    // Check if there are any phone numbers
    const hasAnyPhone = contact.cellPhone || contact.workPhone || contact.homePhone;


    return (
        <div className="mb-4">
            <div className="p-5 bg-white rounded-lg border border-slate-200 shadow-sm">
                {/* Header with contact name and role */}
                <div className="flex items-start justify-between mb-3">
                    <div>
                        <h3 className="font-medium text-slate-900 flex items-center text-base">
                            <User className="h-5 w-5 mr-2 text-blue-500" />
                            {contact.name || "Unnamed Contact"}
                        </h3>
                        <div className="flex items-center text-slate-500 text-xs mt-1">
                            <span className="pl-7 flex items-center">
                                <Contact className="h-3 w-3 mr-1 text-slate-400" />
                                Property Contact
                            </span>
                        </div>
                    </div>
                </div>

                {/* Main content */}
                <div className="space-y-3 text-sm pl-1">
                    {/* Email section */}
                    <div className="flex items-center text-slate-700 py-1">
                        <Mail className="h-4 w-4 mr-3 text-blue-500 flex-shrink-0" />
                        {contact.email ? (
                            <a href={`mailto:${contact.email}`} className="hover:text-blue-600 transition-colors">
                                {contact.email}
                            </a>
                        ) : (
                            <span className="text-slate-400 italic">No email provided</span>
                        )}
                    </div>


                    {/* Phone numbers section */}
                    <div className="border-t border-slate-100 pt-3 mt-2">
                        <button
                            onClick={() => setShowPhones(!showPhones)}
                            className="flex items-center text-slate-700 hover:text-blue-600 w-full justify-between transition-colors py-1"
                        >
                            <div className="flex items-center">
                                <Phone className="h-4 w-4 mr-3 text-blue-500 flex-shrink-0" />
                                <span className={!hasAnyPhone ? "text-slate-400 italic" : ""}>
                                    {hasAnyPhone ? 'Phone Numbers' : 'No Phone Numbers Available'}
                                </span>
                            </div>
                            {hasAnyPhone && (
                                showPhones ?
                                    <ChevronDown className="h-4 w-4 text-slate-400" /> :
                                    <ChevronRight className="h-4 w-4 text-slate-400" />
                            )}
                        </button>

                        {showPhones && hasAnyPhone && (
                            <div className="mt-2 pl-7 space-y-2 pb-1">
                                {contact.cellPhone && (
                                    <div className="flex justify-between items-center text-slate-700 group">
                                        <span>Cell:</span>
                                        <a href={`tel:${contact.cellPhone}`} className="hover:text-blue-600 transition-colors">
                                            {formatPhone(contact.cellPhone)}
                                        </a>
                                    </div>
                                )}
                                {contact.workPhone && (
                                    <div className="flex justify-between items-center text-slate-700">
                                        <span>Work:</span>
                                        <a href={`tel:${contact.workPhone}`} className="hover:text-blue-600 transition-colors">
                                            {formatPhone(contact.workPhone)}
                                        </a>
                                    </div>
                                )}
                                {contact.homePhone && (
                                    <div className="flex justify-between items-center text-slate-700">
                                        <span>Home:</span>
                                        <a href={`tel:${contact.homePhone}`} className="hover:text-blue-600 transition-colors">
                                            {formatPhone(contact.homePhone)}
                                        </a>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};